import { render, staticRenderFns } from "./AddSeries.vue?vue&type=template&id=90487958&scoped=true&"
import script from "./AddSeries.vue?vue&type=script&lang=js&"
export * from "./AddSeries.vue?vue&type=script&lang=js&"
import style0 from "./AddSeries.vue?vue&type=style&index=0&id=90487958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90487958",
  null
  
)

export default component.exports